// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_eY","advertDetailContacts__header":"c-n_eZ"};